import router from '@/router'
import store from '@/store'

export default function createRoute({params, query}) {
  const $route = router.currentRoute
  const state = store.state.vacancies

  const newRoute = {
    params: {
      ...$route.params,
      ...params
    },
    query: {
      categories: $route.query.categories || null,
      [state.otherKeys.SORT]: $route.query[state.otherKeys.SORT],
      ...query
    }
  }
  //console.log('newRoute', newRoute)

  const staticFilters = newRoute.params.staticFilters
  const dynamicFilters = newRoute.params.dynamicFilters

  if (!newRoute.query.categories) {
    delete newRoute.query.categories
  }

  if (isArrayEmpty(staticFilters) && isArrayEmpty(dynamicFilters)) {
    newRoute.name = 'vacancies'
  } else if (isArrayEmpty(staticFilters)) {
    newRoute.name = 'vacancies-with-dynamic'
  } else if (isArrayEmpty(dynamicFilters)) {
    newRoute.name = 'vacancies-with-static'
  } else {
    newRoute.name = 'vacancies-with-static&dynamic'
  }

  return newRoute
}


function isArrayEmpty(arr) {
  return !arr || !arr.length
}
